import { render, staticRenderFns } from "./GiftsHortense.vue?vue&type=template&id=aff8ad6c&scoped=true&"
import script from "./GiftsHortense.vue?vue&type=script&lang=js&"
export * from "./GiftsHortense.vue?vue&type=script&lang=js&"
import style0 from "./GiftsHortense.vue?vue&type=style&index=0&id=aff8ad6c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aff8ad6c",
  null
  
)

export default component.exports